import { PosDataServiceMode } from 'generated/graphql-gateway';
import { useFeatureDonation } from 'hooks/use-feature-donation';
import { useServiceModeContext } from 'state/service-mode';
import { ServiceMode } from 'state/service-mode/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { getEntryPriceOrZero } from 'state/unified-menu/utils';

export type TDonation = {
  id: string;
  name: string;
  price: number;
};

export const useDonations = () => {
  const { featureDonation, loading } = useFeatureDonation();
  const { indexedMenu } = useUnifiedMenuContext();
  const { serviceMode } = useServiceModeContext();
  const posServiceMode =
    serviceMode === ServiceMode.DELIVERY ? PosDataServiceMode.DELIVERY : PosDataServiceMode.PICKUP;

  const donations: TDonation[] = [];

  featureDonation?.donationItemList?.forEach(item => {
    const menuItem = indexedMenu.find(item?._id || '');
    const price = getEntryPriceOrZero(menuItem, posServiceMode);
    if (!menuItem || price === 0) {
      return;
    }
    donations.push({
      id: item?._id || '',
      name: item?.name?.locale || '',
      price,
    });
  });

  return { loading, donations, isDonationsEnabled: donations.length > 0 };
};
